import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import DraftList from "@/components/menu-management/dessert/dessert/draft-list-tabs";
import DessertListTabs from "@/components/menu-management/dessert/dessert/dessert-list-tabs";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  fetchAllDesserts,
  clearDessertMessages,
} from "@/redux/slice/menu-manage-slice/dessert-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import useAuth from "@/hooks/useAuth";
import hasPermission from "@/hooks/hasPermission";

function Dessert() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector((state) => state.menuManage.dessert);

  useEffect(() => {
    dispatch(fetchAllDesserts(user?.restaurant_id));
    dispatch(clearDessertMessages());
    dispatch(clearItemVariants());
  }, [user?.restaurant_id]);

   if (getLoading) return <TableSkeleton links={backofficeLinks} />

  return (
    <Layout2
      pageName={{ title: "Dessert List" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Dessert", path: "/backoffice/menu/dessert" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
          {hasPermission("back_office.menu_management.create_dessert") && (
            <Link to={"/backoffice/menu/dessert/create"}>
              <Button>
                <Plus /> Create Dessert
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="menu-dessert" className="bg-transparent relative" defaultValue="drink">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Dessert List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <DessertListTabs />
          <DraftList />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default Dessert;
